// extracted by mini-css-extract-plugin
export var standaloneTable = "_fk-0";
export var withExtraHeader = "_fk-1";